import { debounce } from '@owc-utils/Events/Debounce';
import { HotspotPanoramaOverlay } from './HotspotPanorama';

export function removeSlot(component: Element | null, selector: string[]) {
  if (component) {
    selector.forEach(function(selectedSelector) {
      const removedItem = component.querySelector(selectedSelector);
      removedItem && removedItem.remove();
    });
  }
}

export function showOverlayAgain(component: HotspotPanoramaOverlay, eventName: string) {
  const element = component;
  const debounceShowingTwoFingersOverlayMessage = debounce(
    250,
    () => {
      element.isTwoFinger = true;
      element.hideHotspotTabs(component.componentId);
    },
    true,
  );
  let timeoutId: number;

  if (element.viewer.on) {
    element.viewer.on(eventName, () => {
      // Skip when the sidepanel is opened
      if (element.isSidepanelOpen) {
        return;
      }

      // Call debounced function to not update state every time the user is dragging
      // the panorama using 1 finger; slow down the execution of the function for performance reasons.
      debounceShowingTwoFingersOverlayMessage();

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      timeoutId = window.setTimeout(() => {
        element.isTwoFinger = false;
        element.showHotspotTabs(component.componentId);
      }, 2000);
    });
  }
}
